/** Статусы оплаты, при которых первая покупка уже совершена */
const COMPLETED_PAYMENT_STATUSES = [
    'package_v2_payed',
    'package_payed',
    'subscription_migrated_to_package_v2',
]

export function hasUserCompletedPurchase(userSession?: { payment_status?: string | null } | null): boolean {
    const status = userSession?.payment_status
    if (!status) {
        return false
    }
    return COMPLETED_PAYMENT_STATUSES.includes(status)
}

/**
 * Промокод с бонусом на первую покупку — только если покупок ещё не было.
 */
export function getFirstPurchasePromoCode(
    userSession?: { active_promo_code?: Record<string, unknown> | null; payment_status?: string | null } | null
): Record<string, unknown> | null {
    const promo = userSession?.active_promo_code
    if (!promo || !promo.is_promo_payment) {
        return null
    }
    if (hasUserCompletedPurchase(userSession)) {
        return null
    }
    return promo
}

/** Бонус к пакету в корзине: «+N по коду XXX», как в OrderInfo */
export function formatPromoPackageBonus(
    promo: Record<string, unknown> | null | undefined,
    prepaidDocumentsCount: number
): string | null {
    if (!promo?.is_promo_payment || !prepaidDocumentsCount) {
        return null
    }
    const promoCodeName = promo.code_name
    const additionalBonusPercent = promo.payment_add_documents_by_percent
    if (!promoCodeName || additionalBonusPercent == null) {
        return null
    }
    try {
        const additionalValue = Math.ceil(
            prepaidDocumentsCount * Number.parseFloat(String(additionalBonusPercent)) / 100
        )
        if (!additionalValue) {
            return null
        }
        return `+${additionalValue} по коду ${promoCodeName}`
    } catch {
        return null
    }
}

/** Текст для плашки профиля: код уже активирован + краткое описание бонуса */
export function formatActivatedPromoForProfile(
    promo: Record<string, unknown> | null | undefined
): { codeName: string; bonusHint: string | null } | null {
    if (!promo?.code_name || typeof promo.code_name !== 'string') {
        return null
    }
    const percent = promo.payment_add_documents_by_percent
    const bonusHint =
        promo.is_promo_payment && percent != null
            ? `+${percent}% к количеству договоров при первой оплате пакета`
            : null
    return { codeName: promo.code_name, bonusHint }
}
